function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';

var generatePlaceholder = function generatePlaceholder(name) {
  return function (_React$PureComponent) {
    _inherits(_class, _React$PureComponent);

    function _class(props) {
      _classCallCheck(this, _class);

      var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

      console.warn('Warning: attempting to use component named ' + name + ', but it wasn\'t found');
      return _this;
    }

    _class.prototype.render = function render() {
      var _props = this.props,
          idyll = _props.idyll,
          updateProps = _props.updateProps,
          hasError = _props.hasError,
          props = _objectWithoutProperties(_props, ['idyll', 'updateProps', 'hasError']);

      return React.createElement('div', props);
    };

    return _class;
  }(React.PureComponent);
};
export { generatePlaceholder };


//////////////////
// WEBPACK FOOTER
// ./node_modules/idyll-document/dist/es/components/placeholder.js
// module id = 645
// module chunks = 0